module.exports = __webpack_public_path__ + "img/Daoud.42824f0.png";